export const APP_NAME = 'Raflr';

export const CATEGORIES = [
  { value: 'electronics', label: 'Electronics' },
  { value: 'furniture', label: 'Furniture' },
  { value: 'gaming', label: 'Gaming' },
  { value: 'fashion', label: 'Fashion' },
  { value: 'sports', label: 'Sports & Outdoors' },
  { value: 'collectibles', label: 'Collectibles' },
  { value: 'home', label: 'Home & Garden' },
  { value: 'toys', label: 'Toys & Games' },
  { value: 'music', label: 'Music & Instruments' },
  { value: 'books', label: 'Books & Media' },
  { value: 'vehicles', label: 'Vehicles & Parts' },
  { value: 'other', label: 'Other' },
];

export const CONDITIONS = [
  { value: 'new', label: 'Brand New', description: 'Unused, in original packaging' },
  { value: 'likeNew', label: 'Like New', description: 'Barely used, excellent condition' },
  { value: 'good', label: 'Good', description: 'Used but well maintained' },
  { value: 'fair', label: 'Fair', description: 'Shows wear but fully functional' },
];

export const RAFFLE_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  ACTIVE: 'active',
  ENDED: 'ended',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

export const TICKET_LIMITS = {
  MIN_PRICE: 100, // cents (€1)
  MAX_PRICE: 50000, // cents (€500)
  MIN_QUANTITY: 10,
  MAX_QUANTITY: 1000,
  MAX_PER_PURCHASE: 10,
};

export const RAFFLE_LIMITS = {
  MIN_PHOTOS: 1,
  MAX_PHOTOS: 8,
  MIN_DAYS: 1,
  MAX_DAYS: 30,
  MIN_THRESHOLD: 50,
  MAX_THRESHOLD: 100,
};

export const PLATFORM_FEE_PERCENT = 5; // 5% on successful sales

export const HANDOVER_TIMEOUT_HOURS = 48;

// Location areas for pickup - used in Browse filters
// Must match values from StepLocation.jsx COUNTIES
export const AREAS = [
  // Dublin Postal Districts
  { value: 'Dublin 1', label: 'Dublin 1' },
  { value: 'Dublin 2', label: 'Dublin 2' },
  { value: 'Dublin 3', label: 'Dublin 3' },
  { value: 'Dublin 4', label: 'Dublin 4' },
  { value: 'Dublin 5', label: 'Dublin 5' },
  { value: 'Dublin 6', label: 'Dublin 6' },
  { value: 'Dublin 6W', label: 'Dublin 6W' },
  { value: 'Dublin 7', label: 'Dublin 7' },
  { value: 'Dublin 8', label: 'Dublin 8' },
  { value: 'Dublin 9', label: 'Dublin 9' },
  { value: 'Dublin 10', label: 'Dublin 10' },
  { value: 'Dublin 11', label: 'Dublin 11' },
  { value: 'Dublin 12', label: 'Dublin 12' },
  { value: 'Dublin 13', label: 'Dublin 13' },
  { value: 'Dublin 14', label: 'Dublin 14' },
  { value: 'Dublin 15', label: 'Dublin 15' },
  { value: 'Dublin 16', label: 'Dublin 16' },
  { value: 'Dublin 17', label: 'Dublin 17' },
  { value: 'Dublin 18', label: 'Dublin 18' },
  { value: 'Dublin 20', label: 'Dublin 20' },
  { value: 'Dublin 22', label: 'Dublin 22' },
  { value: 'Dublin 24', label: 'Dublin 24' },
  // Dublin Suburbs
  { value: 'Dún Laoghaire', label: 'Dún Laoghaire' },
  { value: 'Swords', label: 'Swords' },
  { value: 'Malahide', label: 'Malahide' },
  { value: 'Howth', label: 'Howth' },
  { value: 'Bray', label: 'Bray' },
  { value: 'Blackrock', label: 'Blackrock' },
  { value: 'Sandyford', label: 'Sandyford' },
  { value: 'Tallaght', label: 'Tallaght' },
  { value: 'Blanchardstown', label: 'Blanchardstown' },
  { value: 'Clondalkin', label: 'Clondalkin' },
  // Leinster
  { value: 'Carlow', label: 'Carlow' },
  { value: 'Kildare', label: 'Kildare' },
  { value: 'Kilkenny', label: 'Kilkenny' },
  { value: 'Laois', label: 'Laois' },
  { value: 'Longford', label: 'Longford' },
  { value: 'Louth', label: 'Louth' },
  { value: 'Meath', label: 'Meath' },
  { value: 'Offaly', label: 'Offaly' },
  { value: 'Westmeath', label: 'Westmeath' },
  { value: 'Wexford', label: 'Wexford' },
  { value: 'Wicklow', label: 'Wicklow' },
  // Munster
  { value: 'Clare', label: 'Clare' },
  { value: 'Cork', label: 'Cork' },
  { value: 'Kerry', label: 'Kerry' },
  { value: 'Limerick', label: 'Limerick' },
  { value: 'Tipperary', label: 'Tipperary' },
  { value: 'Waterford', label: 'Waterford' },
  // Connacht
  { value: 'Galway', label: 'Galway' },
  { value: 'Leitrim', label: 'Leitrim' },
  { value: 'Mayo', label: 'Mayo' },
  { value: 'Roscommon', label: 'Roscommon' },
  { value: 'Sligo', label: 'Sligo' },
  // Ulster (ROI)
  { value: 'Cavan', label: 'Cavan' },
  { value: 'Donegal', label: 'Donegal' },
  { value: 'Monaghan', label: 'Monaghan' },
];
